"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.ReceiptsContainer=exports.OldReceiptsButtonContainer=exports.NotFoundWrapper=exports.MainWrapper=exports.ImageContainer=exports.EmailTable=exports.DropdownMenuItem=exports.DropdownMenu=exports.DropdownContainer=exports.DropdownButton=exports.DigitalLoaderContainer=void 0;const ReceiptsContainer=exports.ReceiptsContainer=_styledComponents.default.div`
    padding: 0px !important;
    margin: 0px;
    display: flex;
    justify-content: left;
`,MainWrapper=exports.MainWrapper=_styledComponents.default.div`
    width: 375px;
`,NotFoundWrapper=exports.NotFoundWrapper=_styledComponents.default.div`
    text-align: center;
    padding: 2rem;
    
    .notFound {
        font-size: 22px;
        font-weight: 600;
    }
`,OldReceiptsButtonContainer=exports.OldReceiptsButtonContainer=_styledComponents.default.div`
     text-align: center;
    .receipts-btn {
        font-weight: 400;
        background: none;
        white-space: nowrap;
        cursor: pointer;
        border: 1px solid transparent;
        padding: 6px 12px;
        font-size: 16px;
        line-height: 1.42857143;
        border-radius: 4px;
        margin: 5px 10px 5px 0px;
        color: #7B1A27;
    }
`,DigitalLoaderContainer=exports.DigitalLoaderContainer=_styledComponents.default.div`
    text-align: center;
`,EmailTable=exports.EmailTable=_styledComponents.default.table`
     padding: 20px 0px 24px 0px;
    thead td:first-child{
        width: 55px;
        text-align: left;
    }

    thead td:last-child {
          width: 320px;
        text-align: center;
    }

    tbody td:first-child {
         width: 55px;
        text-align: left;
    }

    tbody td:last-child {
        max-width: 320px;
        text-align: left;
    }
`,ImageContainer=exports.ImageContainer=_styledComponents.default.div`
    display: flex;
    align-self: flex-start;

    .send-email-icon {
      width: 45px;
      height: 35px;
    }

    .email-btn {
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
    }
`,DropdownContainer=exports.DropdownContainer=_styledComponents.default.div`
    position: relative;
    display: inline-block;
`,DropdownButton=exports.DropdownButton=_styledComponents.default.button`
    background-color: #fff !important;
    border: 1px solid #2b0810;
    border-radius: 0.5rem;
    color: #2b0810;
    padding: 12px;
    font-size: 16px;
    cursor: pointer;
    text-align: left;
    min-width: 140px;
    &:after {
        content: "";
        display: block;
        position: absolute;
        right: 10px;
        top: 50%;
        transform: rotate(45deg) translateY(-70%) translateX(-50%);
        border: solid #2B0810;
        border-width: 0 2px 2px 0;
        padding: 3px;
        transition: transform 0.2s ease-in-out;
        transform-origin: center;
    }
`,DropdownMenu=exports.DropdownMenu=_styledComponents.default.div`
    position: absolute;
    top: 100%;
    left: 0;
    background-color: #fff;
    z-index: 1000;
    float: left;
    min-width: 8.5rem;
    padding: 0.5rem 0;
    margin: 0.25rem 0 0 ;
    font-size: 1rem;
    color: #2b0810;
    text-align: left;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.15);
    border-radius: 0.25rem
`,DropdownMenuItem=exports.DropdownMenuItem=_styledComponents.default.button`
    border-style: unset;
    display: block;
    width: 100%;
    max-width: 100%;
    background-color: unset;
    font-size: unset;
    text-align: unset;
    font-family: unset;
    padding: 12px 16px;
    cursor: pointer;
    &:hover {
        background-color: #f1f1f1;
    }
`;